import { render, staticRenderFns } from "./mailing_init.vue?vue&type=template&id=ab36b04e"
import script from "./mailing_init.vue?vue&type=script&lang=js"
export * from "./mailing_init.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports